<template>
  <div class="about">
    <page-header :title="$t('player.edit')" :desc="getName">
      <li class="breadcrumb-item"><router-link :to="{name:'players.index'}">{{ $tc('player.name', 2) }}</router-link></li>
      <li class="breadcrumb-item">{{getName}}</li>
    </page-header>
    <page-content>
      <ntm-block v-if="allTags.length" :title="$tc('playerTag.name', 2)" :collapsable="false">
        <div class="pb-3">
          <v-select
            v-model="selectedTags"
            :options="allTags"
            :multiple="true"
            label="name"
            :reduce="tag => tag"
            @input="onTagsChanged"
          >
            <template #option="tag">
              <span class="badge mr-2" :style="tagBadgeStyle(tag)">{{ tag.name }}</span>
            </template>
            <template #selected-option="tag">
              <span class="badge" :style="tagBadgeStyle(tag)">{{ tag.name }}</span>
            </template>
          </v-select>
        </div>
      </ntm-block>
      <form @submit.prevent="onSubmit()">
        <ntm-block :title="$tc('image.name', 1)" :init-collapse="false">
          <template slot="options">
            <span>{{ $t('ratio') }}: <span class="font-weight-bold">1:1</span>, {{ $t('size') }}: <span class="font-weight-bold">500x500</span></span>
          </template>
          <ntm-crop entity-type="player" :entity-uuid="$route.params.uuid" conversion="lg" collection="profile" :circle="true"></ntm-crop>
        </ntm-block>
        <ntm-block>
          <formly-form :form="form" :model="model" :fields="fields"></formly-form>
          <button class="btn btn-success push-15">{{$t('save')}}</button>
        </ntm-block>
      </form>
    </page-content>
  </div>
</template>

<script>
import fields from './formDefinition'
import PlayerService from '@/services/player.service'
import PlayerTagService from '@/services/playerTag.service'
import router from '@/router'

export default {
  // required properties, field, form, model
  data () {
    return {
      form: {},
      model: {},
      fields: fields,
      profile: '',
      uploading: false,
      allTags: [],
      selectedTags: []
    }
  },
  beforeRouteEnter (to, from, next) {
    Promise.all([
      PlayerService.show(to.params.uuid),
      PlayerTagService.index()
    ]).then(([playerResponse, tagsResponse]) => {
      next(vm => {
        vm.setData(playerResponse.data)
        vm.allTags = tagsResponse.data
      })
    })
  },
  methods: {
    setData (data) {
      this.model = data
      this.selectedTags = data.player_tags || []
    },
    onSubmit () {
      PlayerService.update(this.model.uuid, this.model).then((response) => {
        setTimeout(() => {
          router.push({ name: 'players.index' })
        }, 300)
      }).catch((err) => {
        this.form.$errors = err.response.data.errors
      })
    },
    onTagsChanged (tags) {
      const uuids = (tags || []).map(t => t.uuid)
      PlayerService.updateTags(this.model.uuid, { player_tag_uuids: uuids })
    },
    tagBadgeStyle (tag) {
      if (!tag || !tag.color) return {}
      return { backgroundColor: tag.color, color: '#fff' }
    }
  },
  computed: {
    getName () {
      if (this.model.middleName) {
        return this.model.lastName + ' ' + this.model.middleName + ' ' + this.model.firstName
      }
      return this.model.lastName + ' ' + this.model.firstName
    }
  }
}
</script>
